import React, { useState, useEffect } from "react";
import { FaWhatsapp, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./contact.css";

export default function Contact() {
    const [popup, setPopup] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://api.thetotetherapy.com/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (res.ok) {
      setPopup("Thank you! We’ll contact you soon ✅");
      setForm({ name: "", email: "", message: "" });
    } else {
      setPopup(data.message || "Something went wrong ❌");
    }
  } catch (error) {
    setPopup("Server error ❌");
  }
};
useEffect(() => {
  if (!popup) return;
  const t = setTimeout(() => setPopup(""), 3000);
  return () => clearTimeout(t);
}, [popup]);

  const whatsappNumber = "971545832317";
  const whatsappMessage = "Hi, I need help regarding Tote Therapy products.";
  const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <main className="contactPage">
        {popup && (
  <div className="contactPopup">
    {popup}
    <button onClick={() => setPopup("")}>✕</button>
  </div>
)}
      {/* Header */}
      <section className="contactHeader">
        <div className="contactHeader__inner">
         <h1 className="contactTitle">
  <FaPhoneAlt className="contactTitleIcon" />
  Contact Us
</h1>
          <p>
            If you need help with anything, feel free to contact us — we’re here for you.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="contactContent">
        <div className="contactGrid">
          {/* Left: Info */}
          <div className="contactCard">
            <h2>Get in touch</h2>

            <div className="contactInfoItem">
              <FaMapMarkerAlt />
              <div>
                <h4>Location</h4>
                <p>
                  Inside Capitol Real Estate Compound - Warehouse 17M3, Al Qouz 4,
                  Al Asayel Street 17, Sector, Dubai, United Arab Emirates
                </p>
              </div>
            </div>

            <div className="contactInfoItem">
              <FaEnvelope />
              <div>
                <h4>Email</h4>
                <p>support@totetherapy.com</p>
              </div>
            </div>

            <div className="contactInfoItem">
              <FaPhoneAlt />
              <div>
                <h4>Phone</h4>
                <p>+971545832317</p>
              </div>
            </div>

            <a className="whatsappBtn" href={whatsappURL} target="_blank" rel="noreferrer">
              <FaWhatsapp /> Chat on WhatsApp
            </a>

            {/* Map */}
            <div className="mapWrap">
              <iframe
                title="Tote Therapy Location"
                src="https://maps.google.com/maps?q=25.1394,55.2444&z=16&output=embed"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Form */}
          <div className="contactCard">
            <h2>Send a message</h2>
            <p className="muted">
              We’ll reply as soon as possible.
            </p>

            <form className="contactForm" onSubmit={handleSubmit}>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />

              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Your email"
                type="email"
                required
              />

              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Write your message..."
                rows="6"
                required
              />

              <button type="submit" className="sendBtn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}